import axios, { endpoints } from 'src/utils/axios';

import { LockedQuantity } from '../types';

export async function getCartLocks(eventId: number) {
  const url = endpoints.cartLocks(eventId);
  const response = await axios.get<LockedQuantity[]>(url);

  return response.data;
}
